export default __webpack_public_path__ + "static/media/Category_Appliances_135x195.08ab67a1.jpg";